import React, { PureComponent } from 'react';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './Header.style';
import HeaderNav from '../nav/HeaderNav';

class Header extends PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root} elevation={4}>
        {/* <HeaderNav /> */}
      </Paper>
    )
  }
}

export default withStyles(styles)(Header)